import useTypedSelector from '../../../common/hook/useTypedSelector';
import NoItems from '../../../commonSub/component/NoItems';
import GridModule from '../../common/component/GridModule';
import HomeFooter from '../../common/component/HomeFooter';
import useMainListEventHandler from '../hook/useMainListEventHandler';

export default function TodayFreeSeries() {
  const todayFreeSeries = useTypedSelector(state => state.main.todayFreeSeries);
  const {
    handleClickBigContent,
    handleClickContent,
    sendViewImpBigContent,
    sendViewImpContent,
  } = useMainListEventHandler();

  const hasContent = todayFreeSeries?.bigContent || todayFreeSeries?.contents;

  if (!hasContent) {
    return (
      <NoItems
        className="leading-24"
        textKey="schedule_empty"
        beforeElement={<HomeFooter isBottomFixed />}
      />
    );
  }

  return (
    <>
      <GridModule
        showAllContents
        item={todayFreeSeries}
        onClickBigContent={({content, index}) =>
          handleClickBigContent({item: todayFreeSeries, content, index})
        }
        onClickContent={({content, index}) =>
          handleClickContent({item: todayFreeSeries, content, index})
        }
        onSendViewImpBigContent={({content, index}) =>
          sendViewImpBigContent({item: todayFreeSeries, content, index})
        }
        onSendViewImpContent={({content, index}) =>
          sendViewImpContent({item: todayFreeSeries, content, index})
        }
      />
      <HomeFooter />
    </>
  );
}
